// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"52ef1c9f","453":"841296c2","696":"8fb8ec38","790":"04fb2e4b","945":"841c235d"}[chunkId] + ".chunk.js";
};